// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-DataExtraction-QualityAssessmentTemplate-DefaultTemplate-components-SectionTitle-module__Title";
export { _1 as "Title" }
